import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { FIELD_TYPES } from '../../../constants';
import MultilineAddress from '../../multiline-address/multiline-address/multiline-address';
const BookingAddress = props => {
  const fieldType = FIELD_TYPES.BOOKINGS_ADDRESS;
  return /*#__PURE__*/React.createElement(MultilineAddress, _extends({}, props, {
    fieldType: fieldType
  }));
};
export default BookingAddress;
//# sourceMappingURL=bookings-address.js.map